module.exports = __webpack_public_path__ + "static/media/vincent-versluis.62324e68.jpg";